// @material-ui
import { makeStyles } from '@material-ui/styles'

export const avatarUploadStyle = theme => ({
  root: {
    position: 'relative',
    display: 'inline-flex',
    width: theme.spacing(7.5),
    marginBottom: theme.spacing(2),
  },

  avatar: {},

  fab: {
    position: 'absolute',
    top: theme.spacing(-1),
    left: '100%',
  },

  progress: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },

  uploadRoot: {
    position: 'relative',
  },

  uploadHelperText: {
    paddingRight: theme.spacing(17),
  },

  uploadFilesGrid: {
    textAlign: 'center',
  },

  uploadButtonGrid: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
})

export const useAvatarUploadStyle = makeStyles(avatarUploadStyle)
